import React, { useState } from 'react';
import '../template/styles/Template.css';
import '../styles/Dashboard.css';

function Dashboard() {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });

  return (
    <div className="dashboard-content">
      <div className="welcome-card">
        <h2>Welcome to DeepEcon</h2>
        <p>You are successfully logged in.</p>
        
        <div className="user-info">
          <p><strong>Username:</strong> {user?.username}</p>
          <p><strong>Email:</strong> {user?.email}</p>
          <p><strong>Member since:</strong> {new Date(user?.created_at).toLocaleDateString()}</p>
        </div>

        <p style={{ marginTop: '30px', color: '#666' }}>
          Your main DeepEcon dashboard and economic news analysis will go here.
        </p>

        <div className="dashboard-grid">
          <div className="card">
            <h3>📊 Economic Data</h3>
            <p>Access real-time economic indicators from World Bank and IMF</p>
          </div>
          <div className="card">
            <h3>📰 News Analysis</h3>
            <p>View AI-powered analysis of economic news with GDP impact assessment</p>
          </div>
          <div className="card">
            <h3>🌍 Country Insights</h3>
            <p>Explore economic data for 80+ countries with detailed analysis</p>
          </div>
          <div className="card">
            <h3>📈 Sentiment Tracking</h3>
            <p>Track economic sentiment changes and market indicators</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
